import React from "react";
import styles from "./SolutionsFeatureGrid.module.scss";

const SolutiosnFeatureGrid = ({ features }) => {
  return (
    <div className={styles.SolutionsFeatureGrid}>
      {features.map((feature, index) => (
        <div className={styles.featureCard} key={index}>
          <div className={styles.iconWrapper}>
            <img src={feature.icon} alt={`${feature.title} Icon`} />
          </div>
          <div className={styles.content}>
            <h3 className={styles.title}>{feature.title}</h3>
            <p className={styles.description}>{feature.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SolutiosnFeatureGrid;
